<template>
  <div>
    <v-container v-show="!isFarmAvailable && myloadingvariable">
      <v-dialog v-model="alert.type" max-width="390" transition="scale-transition">
        <v-card>
          <v-card-title :class="alert.color">
            {{ alert.title }}
          </v-card-title>

          <v-card-text>
            {{ alert.message }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="alert.type = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card class="ma-3">
        <v-card-title>
          Farmer Details
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="farmer" :search="search">
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn small class="ma-2 primary--text" style="width:100px;" outlined @click="dialogFarmItem(item)">
              View Farm
            </v-btn>
            <v-btn small class="ma-2 primary--text" style="width:100px;" outlined @click="editFarmer(item)">
              Edit
            </v-btn>
          </template>
          <template v-slot:[`item.current_date`]="{ item }">
            {{ formatDate(item.current_date) }}
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-container v-if="isFarmAvailable">
      <v-btn class="my-5" color="primary" @click="isFarmAvailable = false" dark large top left>
        Go Back
      </v-btn>
      <template>
        <v-container fluid>
          <v-row justify="end">
            <v-expansion-panels>
              <v-expansion-panel @click="modalShown()" v-for="(item, j) in farm" :key="item.farm_id">
                <v-expansion-panel-header @click="modalShown1(`mymap` + j)">
                  <v-row align="center" no-gutters>
                    <v-col cols="4" sm="1" md="1" justify="end">
                      <div>
                        <v-avatar size="36px">
                          <v-icon color="orange">emoji_nature</v-icon>
                        </v-avatar>
                      </div>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col cols="1" sm="1" md="1"> </v-col>
                    <v-col cols="4" sm="3" md="3">
                      <h4>Field ID : {{ item.farm_id }}</h4>
                    </v-col>
                    <v-col class="hidden-xs-only" sm="5" md="3">
                      <strong>{{ formatDate(item.current_date) }}</strong>
                    </v-col>
                    <v-col class="grey--text text-truncate hidden-sm-and-down ma-2"> </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <!-- <v-divider></v-divider> -->
                  <v-row dense>
                    <v-col class="col-md-12 col-sm-12 ">
                      <v-card class="mx-auto pa-5" outlined>
                        <v-row>
                          <v-col class="col-md-3 col-sm-12 text--secondary ">
                            <v-text-field outlined label="Field ID" readonly="true" :value="item.farm_id"></v-text-field>
                          </v-col>
                          <v-col class="col-md-3 col-sm-12 text--secondary ">
                            <v-text-field outlined label="Acre" readonly="true" :value="item.acre"></v-text-field>
                          </v-col>
                          <v-col class="col-md-3 col-sm-12 text--secondary ">
                            <v-text-field outlined label="Irrigation" readonly="true" :value="item.irrigation"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="col-md-3 col-sm-12 text--secondary">Near by plots </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="col-md-3 col-sm-12 text--secondary ">
                            <v-text-field outlined label="North" readonly="true" :value="item.north"></v-text-field>
                          </v-col>
                          <v-col class="col-md-3 col-sm-12 text--secondary ">
                            <v-text-field outlined label="East" readonly="true" :value="item.east"></v-text-field>
                          </v-col>
                          <v-col class="col-md-3 col-sm-12 text--secondary ">
                            <v-text-field outlined label="South" readonly="true" :value="item.south"></v-text-field>
                          </v-col>
                          <v-col class="col-md-3 col-sm-12 text--secondary ">
                            <v-text-field outlined label="West" readonly="true" :value="item.west"></v-text-field>
                          </v-col>
                          <v-col class="col-md-3 col-sm-12 text--secondary ">
                            <v-text-field outlined label="Plucking number" readonly="true" :value="item.plucking_number"></v-text-field>
                          </v-col>
                          <v-col class="col-md-3 col-sm-12 text--secondary ">
                            <v-text-field outlined label="Seed Type" readonly="true" :value="item.seed_type"></v-text-field>
                          </v-col>
                          <v-col class="col-md-3 col-sm-12 text--secondary " v-if="item.remarks">
                            <v-text-field outlined label="Remarks" readonly="true" :value="item.remarks"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                    <v-col class="col-md-12 col-sm-12">
                      <v-card outlined>
                        <v-row>
                          <v-col class="col-md-6 col-sm-12">
                            <v-carousel class="ma-5 mx-auto" eager="true">
                              <v-btn class="rotate" depressed color="primary" @click="rotateRight">
                                Rotate
                              </v-btn>
                              <v-carousel-item
                                v-for="(item, i) in item.images"
                                :key="i"
                                reverse-transition="fade-transition"
                                transition="fade-transition"
                              >
                                <v-img
                                  height="100%"
                                  width="100%"
                                  :src="getImage(item.label)"
                                  contain
                                  :style="`transform: rotate(${rotate}deg);`"
                                ></v-img>
                              </v-carousel-item>
                            </v-carousel>
                          </v-col>
                          <v-col class="col-md-6 col-sm-12">
                            <template>
                              <v-card class="ma-5" outlined>
                                <div class="footer1">
                                  <l-map
                                    :ref="`mymap` + j"
                                    :zoom="zoom"
                                    :center="getMapCenter(item.location)"
                                    style="height:500px; width: 100%"
                                  >
                                    <l-tile-layer :url="url" />
                                    <l-marker :lat-lng="getLocation(item.location)">
                                      <l-tooltip
                                        :options="{
                                          permanent: true,
                                          interactive: true,
                                        }"
                                      >
                                        <div>Updated Location</div>
                                      </l-tooltip>
                                    </l-marker>
                                    <l-icon-default :image-path="iconUrl" />
                                    <l-polygon :lat-lngs="getPoligonLocations(item.plot_marks)" color="red">
                                      <l-popup content="Plot" />
                                    </l-polygon>
                                  </l-map>
                                </div>
                              </v-card>
                            </template>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-container>
      </template>
    </v-container>
    <v-container class="indicator" v-if="!myloadingvariable">
      <v-progress-circular :size="50" :width="5" color="orange" indeterminate></v-progress-circular>
    </v-container>

    <!-- Edit Farmer Modal -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="itemEdit.dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Edit Farmer</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Farmer ID" v-model="editItem.farmer_id" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Name" v-model="editItem.name"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Mobile" v-model="editItem.mobile" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Village" v-model="editItem.village" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Pin" v-model="editItem.pin" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Total Acre" v-model.number="editItem.total_acre"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="dealers"
                      v-model="editItem.dealer_id"
                      item-text="label"
                      item-value="id"
                      label="Dealer"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="district"
                      v-model="editItem.district_id"
                      item-text="label"
                      item-value="id"
                      label="District"
                      required
                    ></v-select>
                  </v-col>
                  <!-- <v-col cols="12" sm="6">
                    <v-autocomplete
                      :items="states"
                      v-model="editItem.state_id"
                      item-text="label"
                      item-value="id"
                      label="State"
                      required
                    ></v-autocomplete>
                  </v-col> -->
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="itemEdit.dialog = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="updateFarm">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- End -->
  </div>
</template>

<script>
import axios from "axios";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPolygon, LPopup, LTooltip } from "vue2-leaflet";

// import { gmapsMap, gmapsMarker } from "x5-gmaps";
import { apiLink } from "../config";
import { AlertService } from "../utils/AlertService";
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    LPopup,
    LTooltip,
  },
  data() {
    return {
      // map
      zoom: 18,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      search: "",
      myloadingvariable: false,
      alert: {
        color: "info",
        title: null,
        message: null,
        type: null,
      },
      headers: [
        {
          text: "Staff Name",
          align: "start",
          sortable: true,
          value: "user_name",
        },
        {
          text: "Farmer ID",
          align: "start",
          sortable: true,
          value: "farmer_id",
        },
        {
          text: "Added date",
          align: "start",
          sortable: true,
          value: "current_date",
        },
        { text: "Name", value: "name" },
        { text: "Mobile Number", value: "mobile" },
        { text: "Total Acre", value: "total_acre" },
        { text: "District", value: "district" },
        { text: "Actions", align: "end", value: "actions", sortable: false },
      ],
      farmer: [],
      isFarmAvailable: false,
      farm: [],
      rotate: 0,
      itemEdit: {
        dialog: false,
        editIndex: -1,
        editItemId: null,
      },
      editItem: {
        farmer_id: "",
        name: "",
        mobile: "",
        pin: "",
        village: "",
        dealer_id: null,
        district_id: null,
        total_acre: 0,
      },
      district: [],
      states: [],
      dealers: [],
    };
  },
  created() {
    this.initialize();
  },

  mounted() {
    // setTimeout(function() {
    //   window.dispatchEvent(new Event("resize"));
    // }, 250);

    this.$refs.mymap.mapObject._onResize();
  },
  methods: {
    initialize() {
      axios
        .get("farmer/all")
        .then((res) => {
          this.farmer = res.data;
          this.myloadingvariable = true;
        })
        .catch((err) => {
          console.log(err);
        });
      axios
        .get("district?sort=label%2CASC")
        .then((res) => {
          this.district = res.data;
        })
        .catch((err) => {
          console.log(err);
        });

      axios
        .get("states")
        .then((res) => {
          this.states = res.data;
        })
        .catch((err) => {
          console.log(err);
        });

      axios
        .get("dealer?sort=label%2CASC")
        .then((res) => {
          this.dealers = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dialogFarmItem(item) {
      axios
        .get(`farm/farm/${item.farmer_id}`)
        .then((res) => {
          //   this.userLoc = res.data;
          //   this.myloadingvariable = false;
          this.farm = res.data;
          if (res.data.length > 0) {
            this.isFarmAvailable = true;
          } else {
            this.alert.color = "red--text";
            this.alert.title = "Sorry";
            this.alert.message = "No Farm found for selected Farmer";
            this.alert.type = true;
          }
          //   this.closeMap();
        })
        .catch((err) => {
          console.log(err);
          //   this.closeMap();
        });
      //   this.dialogMap = false;
    },
    editFarmer(item) {
      this.itemEdit.editIndex = this.farmer.findIndex((x) => x.id === item.id);
      this.itemEdit.dialog = true;
      this.itemEdit.editItemId = item.id;
      Object.keys(this.editItem).forEach((key) => {
        this.editItem[key] = item[key];
      });
    },
    async updateFarm() {
      axios
        .patch(`farmer/${this.itemEdit.editItemId}`, this.editItem)
        .then(() => {
          AlertService.success(`Farmer details updated successfully.`);
          this.itemEdit.dialog = false;
          this.farmer[this.itemEdit.editIndex] = Object.assign(this.farmer[this.itemEdit.editIndex], this.editItem);
        })
        .catch((error) => {
          console.log(error);
          AlertService.error(error.response.data.message);
        });
    },
    formatDate(date) {
      let monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      //  month = "" + (d.getMonth() + 1),
      var d = new Date(date),
        month = "" + monthNames[d.getMonth()],
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      // var d = dateVar.add(-1).day().toString('dd-MMM-yyyy');

      return [day, month, year].join(" - ");
    },
    getImage(img) {
      let data = apiLink + "/" + img;
      console.log(data);
      return data;
    },
    getLocation(loc) {
      return latLng(loc.lat, loc.long);
    },
    getMapCenter(loc) {
      return [loc.lat, loc.long];
    },

    getPoligonLocations(plot_marks) {
      let arr = [];
      plot_marks.forEach((element) => {
        arr.push([element.lat, element.long]);
      });
      console.log(arr);
      return arr;
    },
    modalShown() {
      this.rotate = 0;
      setTimeout(() => {
        this.$refs.mymap.mapObject.invalidateSize();
      }, 100);
    },

    modalShown1(j) {
      this.rotate = 0;
      let refMap = j;
      console.log(refMap);
      setTimeout(() => {
        this.$refs[j][0].mapObject.invalidateSize();
      }, 100);
    },
    onResize() {
      // this.$refs.mymap.mapObject._onResize();
      this.$refs.mymap.mapObject.invalidateSize();
    },

    // map
    // end map
    rotateRight() {
      console.log(this.rotate);
      this.rotate -= 90;
    },
  },
};
</script>
<style>
/* @import "~leaflet/dist/leaflet.css"; */
/* @import "http://cdn.leafletjs.com/leaflet-0.7.5/leaflet.css"; */
.compact-form {
  transform: scale(0.865);
  transform-origin: center;
}
</style>
<style lang="scss">
.vue2leaflet-map {
  z-index: 1;
}
.v-stepper {
  box-shadow: none;
}

.foobar1 {
  width: 100%;
  height: 500px;
}
.v-progress-circular {
  position: absolute;
  top: 100%;
  left: 50%;
}
.indicator {
  height: 40vh;
}
.rotate {
  position: absolute;
  right: 1%;
  bottom: 1%;
  z-index: 10;
}
</style>
